module.exports = __webpack_public_path__ + "img/secondday1-2.29e8ef84.jpg";